import styled from 'styled-components';
import { Link } from 'gatsby';
import {
  headLine4,
  hoverEffect,
  hoverImageEffect,
  lineClamp,
  linkText,
  para2,
} from '../../theme/GlobalStyle';

export const Container = styled.li`
  width: 100%;
  display: flex;
  flex-flow: column;
  figure {
    margin: 0;
    position: relative;
    ${hoverImageEffect()}

    figcaption {
      position: absolute;
      top: 10px;
      left: 10px;
      color: ${(props) => props.theme.color.white};
      text-transform: uppercase;
    }
  }
`;

export const Description = styled.div`
  color: ${(props) => props.theme.color.black};
  h3 {
    margin: 15px 0 0;
    ${headLine4}

    a {
      ${lineClamp()}
      ${hoverEffect()};
    }
  }
  p {
    margin: 8px 0 0;
    ${para2}
  }
`;
export const BlueLink = styled(Link)`
  margin: 10px 0;
  display: block;
  ${linkText}
  text-decoration: underline;
`;

export const NewsItemBottom = styled.div`
  margin: 10px 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  ${linkText}
  color: ${(props) => props.theme.color.textLight};

  .divider {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 100%;
    margin: 0 8px 0 6px;
    background-color: ${(props) => props.theme.color.textLight};
  }

  .author-container {
    margin: 0 5px 0 0;
  }
  .author-name {
    color: ${(props) => props.theme.color.primary};
    transition: text-decoration ease-in-out 0.2s;
  }

  @media (min-width: 1024px) {
    .author-name:hover {
      text-decoration: underline;
    }
  }
`;
